import { Component, OnInit } from '@angular/core';
import { IServiceList, IServicePost, ServicesPageService } from '../../services-page.service';

@Component({
  selector: 'app-service-web-development',
  templateUrl: './service-web-development.component.html',
  styleUrls: ['./service-web-development.component.css']
})
export class ServiceWebDevelopmentComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {
  }
}
